<div [formGroup]="formGroup" class="form-group">
  <a [routerLink]="[]" (click)="config?.clickHandler($event)">{{ config.value }}</a>
</div>
